module.exports = __webpack_public_path__ + "media/images/oak/sprite-aed408e373bce7de1ec19c6b89bd2e50.svg";